import http from "@/http/aisea/axios";
const resource = "/enterprises/manning/crews";

export default {
  fetchCrews(payload) {
    return http.get(`${resource}`, {
      params: payload,
    });
  },
  fetchSearchParameter() {
    return http.get(`${resource}/search_parameter`);
  },
};
